/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProcessEparakstsRouteImport } from './routes/ProcessEparaksts'
import { Route as AbsenceRouteImport } from './routes/absence'
import { Route as AcceptInviteRouteImport } from './routes/accept-invite'
import { Route as AgreementTemplatesRouteImport } from './routes/agreement-templates'
import { Route as AgreementsRouteImport } from './routes/agreements'
import { Route as ApplicationsRouteImport } from './routes/applications'
import { Route as CompleteEduRegistrationRouteImport } from './routes/complete-edu-registration'
import { Route as EduInternsRouteImport } from './routes/edu-interns'
import { Route as EmailsRouteImport } from './routes/emails'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as FutureInternshipsRouteImport } from './routes/future-internships'
import { Route as GradingRouteImport } from './routes/grading'
import { Route as InstitutionProfileRouteImport } from './routes/institution-profile'
import { Route as InternshipHubRouteImport } from './routes/internship-hub'
import { Route as InternshipsRouteImport } from './routes/internships'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MyAgreementsRouteImport } from './routes/my-agreements'
import { Route as MyCvRouteImport } from './routes/my-cv'
import { Route as MyDevicesRouteImport } from './routes/my-devices'
import { Route as MyDiaryRouteImport } from './routes/my-diary'
import { Route as MyEduInternsRouteImport } from './routes/my-edu-interns'
import { Route as MyOrgInternsRouteImport } from './routes/my-org-interns'
import { Route as MyProfileRouteImport } from './routes/my-profile'
import { Route as MyProgramRouteImport } from './routes/my-program'
import { Route as MyWorkplaceRouteImport } from './routes/my-workplace'
import { Route as OrgAgreementsRouteImport } from './routes/org-agreements'
import { Route as OrgInternsRouteImport } from './routes/org-interns'
import { Route as OrganizationProfileRouteImport } from './routes/organization-profile'
import { Route as PaymentReturnRouteImport } from './routes/payment-return'
import { Route as PaymentsRouteImport } from './routes/payments'
import { Route as ProgramsRouteImport } from './routes/programs'
import { Route as RegisterEduRouteImport } from './routes/register-edu'
import { Route as RegisterOrgRouteImport } from './routes/register-org'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as StudentsRouteImport } from './routes/students'
import { Route as SurveysRouteImport } from './routes/surveys'
import { Route as UserManagementRouteImport } from './routes/user-management'
import { Route as UsersRouteImport } from './routes/users'
import { Route as VacanciesRouteImport } from './routes/vacancies'
import { Route as AgreementsSignRouteImport } from './routes/agreements_.sign'
import { Route as EduInternsInternIdRouteImport } from './routes/edu-interns_.$internId'
import { Route as EparakstsCodeRouteImport } from './routes/eparaksts.$code'
import { Route as InternshipsInternshipIdRouteImport } from './routes/internships_.$internshipId'
import { Route as MyEduInternsInternIdRouteImport } from './routes/my-edu-interns_.$internId'
import { Route as MyOrgInternsPlacementIdRouteImport } from './routes/my-org-interns_.$placementId'
import { Route as OrgInternsPlacementIdRouteImport } from './routes/org-interns_.$placementId'
import { Route as OrganizationProfileCreateRouteImport } from './routes/organization-profile_.create'
import { Route as SurveysSurveyIdRouteImport } from './routes/surveys_.$surveyId'
import { Route as ProgramsProgramIdPlanPointsRouteImport } from './routes/programs_.$programId.plan-points'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProcessEparakstsRoute = ProcessEparakstsRouteImport.update({
  id: '/ProcessEparaksts',
  path: '/ProcessEparaksts',
  getParentRoute: () => rootRouteImport,
} as any)
const AbsenceRoute = AbsenceRouteImport.update({
  id: '/absence',
  path: '/absence',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInviteRoute = AcceptInviteRouteImport.update({
  id: '/accept-invite',
  path: '/accept-invite',
  getParentRoute: () => rootRouteImport,
} as any)
const AgreementTemplatesRoute = AgreementTemplatesRouteImport.update({
  id: '/agreement-templates',
  path: '/agreement-templates',
  getParentRoute: () => rootRouteImport,
} as any)
const AgreementsRoute = AgreementsRouteImport.update({
  id: '/agreements',
  path: '/agreements',
  getParentRoute: () => rootRouteImport,
} as any)
const ApplicationsRoute = ApplicationsRouteImport.update({
  id: '/applications',
  path: '/applications',
  getParentRoute: () => rootRouteImport,
} as any)
const CompleteEduRegistrationRoute = CompleteEduRegistrationRouteImport.update({
  id: '/complete-edu-registration',
  path: '/complete-edu-registration',
  getParentRoute: () => rootRouteImport,
} as any)
const EduInternsRoute = EduInternsRouteImport.update({
  id: '/edu-interns',
  path: '/edu-interns',
  getParentRoute: () => rootRouteImport,
} as any)
const EmailsRoute = EmailsRouteImport.update({
  id: '/emails',
  path: '/emails',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const FutureInternshipsRoute = FutureInternshipsRouteImport.update({
  id: '/future-internships',
  path: '/future-internships',
  getParentRoute: () => rootRouteImport,
} as any)
const GradingRoute = GradingRouteImport.update({
  id: '/grading',
  path: '/grading',
  getParentRoute: () => rootRouteImport,
} as any)
const InstitutionProfileRoute = InstitutionProfileRouteImport.update({
  id: '/institution-profile',
  path: '/institution-profile',
  getParentRoute: () => rootRouteImport,
} as any)
const InternshipHubRoute = InternshipHubRouteImport.update({
  id: '/internship-hub',
  path: '/internship-hub',
  getParentRoute: () => rootRouteImport,
} as any)
const InternshipsRoute = InternshipsRouteImport.update({
  id: '/internships',
  path: '/internships',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const MyAgreementsRoute = MyAgreementsRouteImport.update({
  id: '/my-agreements',
  path: '/my-agreements',
  getParentRoute: () => rootRouteImport,
} as any)
const MyCvRoute = MyCvRouteImport.update({
  id: '/my-cv',
  path: '/my-cv',
  getParentRoute: () => rootRouteImport,
} as any)
const MyDevicesRoute = MyDevicesRouteImport.update({
  id: '/my-devices',
  path: '/my-devices',
  getParentRoute: () => rootRouteImport,
} as any)
const MyDiaryRoute = MyDiaryRouteImport.update({
  id: '/my-diary',
  path: '/my-diary',
  getParentRoute: () => rootRouteImport,
} as any)
const MyEduInternsRoute = MyEduInternsRouteImport.update({
  id: '/my-edu-interns',
  path: '/my-edu-interns',
  getParentRoute: () => rootRouteImport,
} as any)
const MyOrgInternsRoute = MyOrgInternsRouteImport.update({
  id: '/my-org-interns',
  path: '/my-org-interns',
  getParentRoute: () => rootRouteImport,
} as any)
const MyProfileRoute = MyProfileRouteImport.update({
  id: '/my-profile',
  path: '/my-profile',
  getParentRoute: () => rootRouteImport,
} as any)
const MyProgramRoute = MyProgramRouteImport.update({
  id: '/my-program',
  path: '/my-program',
  getParentRoute: () => rootRouteImport,
} as any)
const MyWorkplaceRoute = MyWorkplaceRouteImport.update({
  id: '/my-workplace',
  path: '/my-workplace',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgAgreementsRoute = OrgAgreementsRouteImport.update({
  id: '/org-agreements',
  path: '/org-agreements',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgInternsRoute = OrgInternsRouteImport.update({
  id: '/org-interns',
  path: '/org-interns',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationProfileRoute = OrganizationProfileRouteImport.update({
  id: '/organization-profile',
  path: '/organization-profile',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentReturnRoute = PaymentReturnRouteImport.update({
  id: '/payment-return',
  path: '/payment-return',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsRoute = PaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => rootRouteImport,
} as any)
const ProgramsRoute = ProgramsRouteImport.update({
  id: '/programs',
  path: '/programs',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterEduRoute = RegisterEduRouteImport.update({
  id: '/register-edu',
  path: '/register-edu',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterOrgRoute = RegisterOrgRouteImport.update({
  id: '/register-org',
  path: '/register-org',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const StudentsRoute = StudentsRouteImport.update({
  id: '/students',
  path: '/students',
  getParentRoute: () => rootRouteImport,
} as any)
const SurveysRoute = SurveysRouteImport.update({
  id: '/surveys',
  path: '/surveys',
  getParentRoute: () => rootRouteImport,
} as any)
const UserManagementRoute = UserManagementRouteImport.update({
  id: '/user-management',
  path: '/user-management',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const VacanciesRoute = VacanciesRouteImport.update({
  id: '/vacancies',
  path: '/vacancies',
  getParentRoute: () => rootRouteImport,
} as any)
const AgreementsSignRoute = AgreementsSignRouteImport.update({
  id: '/agreements_/sign',
  path: '/agreements/sign',
  getParentRoute: () => rootRouteImport,
} as any)
const EduInternsInternIdRoute = EduInternsInternIdRouteImport.update({
  id: '/edu-interns_/$internId',
  path: '/edu-interns/$internId',
  getParentRoute: () => rootRouteImport,
} as any)
const EparakstsCodeRoute = EparakstsCodeRouteImport.update({
  id: '/eparaksts/$code',
  path: '/eparaksts/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const InternshipsInternshipIdRoute = InternshipsInternshipIdRouteImport.update({
  id: '/internships_/$internshipId',
  path: '/internships/$internshipId',
  getParentRoute: () => rootRouteImport,
} as any)
const MyEduInternsInternIdRoute = MyEduInternsInternIdRouteImport.update({
  id: '/my-edu-interns_/$internId',
  path: '/my-edu-interns/$internId',
  getParentRoute: () => rootRouteImport,
} as any)
const MyOrgInternsPlacementIdRoute = MyOrgInternsPlacementIdRouteImport.update({
  id: '/my-org-interns_/$placementId',
  path: '/my-org-interns/$placementId',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgInternsPlacementIdRoute = OrgInternsPlacementIdRouteImport.update({
  id: '/org-interns_/$placementId',
  path: '/org-interns/$placementId',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationProfileCreateRoute =
  OrganizationProfileCreateRouteImport.update({
    id: '/organization-profile_/create',
    path: '/organization-profile/create',
    getParentRoute: () => rootRouteImport,
  } as any)
const SurveysSurveyIdRoute = SurveysSurveyIdRouteImport.update({
  id: '/surveys_/$surveyId',
  path: '/surveys/$surveyId',
  getParentRoute: () => rootRouteImport,
} as any)
const ProgramsProgramIdPlanPointsRoute =
  ProgramsProgramIdPlanPointsRouteImport.update({
    id: '/programs_/$programId/plan-points',
    path: '/programs/$programId/plan-points',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/ProcessEparaksts': typeof ProcessEparakstsRoute
  '/absence': typeof AbsenceRoute
  '/accept-invite': typeof AcceptInviteRoute
  '/agreement-templates': typeof AgreementTemplatesRoute
  '/agreements': typeof AgreementsRoute
  '/applications': typeof ApplicationsRoute
  '/complete-edu-registration': typeof CompleteEduRegistrationRoute
  '/edu-interns': typeof EduInternsRoute
  '/emails': typeof EmailsRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/future-internships': typeof FutureInternshipsRoute
  '/grading': typeof GradingRoute
  '/institution-profile': typeof InstitutionProfileRoute
  '/internship-hub': typeof InternshipHubRoute
  '/internships': typeof InternshipsRoute
  '/login': typeof LoginRoute
  '/my-agreements': typeof MyAgreementsRoute
  '/my-cv': typeof MyCvRoute
  '/my-devices': typeof MyDevicesRoute
  '/my-diary': typeof MyDiaryRoute
  '/my-edu-interns': typeof MyEduInternsRoute
  '/my-org-interns': typeof MyOrgInternsRoute
  '/my-profile': typeof MyProfileRoute
  '/my-program': typeof MyProgramRoute
  '/my-workplace': typeof MyWorkplaceRoute
  '/org-agreements': typeof OrgAgreementsRoute
  '/org-interns': typeof OrgInternsRoute
  '/organization-profile': typeof OrganizationProfileRoute
  '/payment-return': typeof PaymentReturnRoute
  '/payments': typeof PaymentsRoute
  '/programs': typeof ProgramsRoute
  '/register-edu': typeof RegisterEduRoute
  '/register-org': typeof RegisterOrgRoute
  '/reset-password': typeof ResetPasswordRoute
  '/students': typeof StudentsRoute
  '/surveys': typeof SurveysRoute
  '/user-management': typeof UserManagementRoute
  '/users': typeof UsersRoute
  '/vacancies': typeof VacanciesRoute
  '/agreements/sign': typeof AgreementsSignRoute
  '/edu-interns/$internId': typeof EduInternsInternIdRoute
  '/eparaksts/$code': typeof EparakstsCodeRoute
  '/internships/$internshipId': typeof InternshipsInternshipIdRoute
  '/my-edu-interns/$internId': typeof MyEduInternsInternIdRoute
  '/my-org-interns/$placementId': typeof MyOrgInternsPlacementIdRoute
  '/org-interns/$placementId': typeof OrgInternsPlacementIdRoute
  '/organization-profile/create': typeof OrganizationProfileCreateRoute
  '/surveys/$surveyId': typeof SurveysSurveyIdRoute
  '/programs/$programId/plan-points': typeof ProgramsProgramIdPlanPointsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/ProcessEparaksts': typeof ProcessEparakstsRoute
  '/absence': typeof AbsenceRoute
  '/accept-invite': typeof AcceptInviteRoute
  '/agreement-templates': typeof AgreementTemplatesRoute
  '/agreements': typeof AgreementsRoute
  '/applications': typeof ApplicationsRoute
  '/complete-edu-registration': typeof CompleteEduRegistrationRoute
  '/edu-interns': typeof EduInternsRoute
  '/emails': typeof EmailsRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/future-internships': typeof FutureInternshipsRoute
  '/grading': typeof GradingRoute
  '/institution-profile': typeof InstitutionProfileRoute
  '/internship-hub': typeof InternshipHubRoute
  '/internships': typeof InternshipsRoute
  '/login': typeof LoginRoute
  '/my-agreements': typeof MyAgreementsRoute
  '/my-cv': typeof MyCvRoute
  '/my-devices': typeof MyDevicesRoute
  '/my-diary': typeof MyDiaryRoute
  '/my-edu-interns': typeof MyEduInternsRoute
  '/my-org-interns': typeof MyOrgInternsRoute
  '/my-profile': typeof MyProfileRoute
  '/my-program': typeof MyProgramRoute
  '/my-workplace': typeof MyWorkplaceRoute
  '/org-agreements': typeof OrgAgreementsRoute
  '/org-interns': typeof OrgInternsRoute
  '/organization-profile': typeof OrganizationProfileRoute
  '/payment-return': typeof PaymentReturnRoute
  '/payments': typeof PaymentsRoute
  '/programs': typeof ProgramsRoute
  '/register-edu': typeof RegisterEduRoute
  '/register-org': typeof RegisterOrgRoute
  '/reset-password': typeof ResetPasswordRoute
  '/students': typeof StudentsRoute
  '/surveys': typeof SurveysRoute
  '/user-management': typeof UserManagementRoute
  '/users': typeof UsersRoute
  '/vacancies': typeof VacanciesRoute
  '/agreements/sign': typeof AgreementsSignRoute
  '/edu-interns/$internId': typeof EduInternsInternIdRoute
  '/eparaksts/$code': typeof EparakstsCodeRoute
  '/internships/$internshipId': typeof InternshipsInternshipIdRoute
  '/my-edu-interns/$internId': typeof MyEduInternsInternIdRoute
  '/my-org-interns/$placementId': typeof MyOrgInternsPlacementIdRoute
  '/org-interns/$placementId': typeof OrgInternsPlacementIdRoute
  '/organization-profile/create': typeof OrganizationProfileCreateRoute
  '/surveys/$surveyId': typeof SurveysSurveyIdRoute
  '/programs/$programId/plan-points': typeof ProgramsProgramIdPlanPointsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/ProcessEparaksts': typeof ProcessEparakstsRoute
  '/absence': typeof AbsenceRoute
  '/accept-invite': typeof AcceptInviteRoute
  '/agreement-templates': typeof AgreementTemplatesRoute
  '/agreements': typeof AgreementsRoute
  '/applications': typeof ApplicationsRoute
  '/complete-edu-registration': typeof CompleteEduRegistrationRoute
  '/edu-interns': typeof EduInternsRoute
  '/emails': typeof EmailsRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/future-internships': typeof FutureInternshipsRoute
  '/grading': typeof GradingRoute
  '/institution-profile': typeof InstitutionProfileRoute
  '/internship-hub': typeof InternshipHubRoute
  '/internships': typeof InternshipsRoute
  '/login': typeof LoginRoute
  '/my-agreements': typeof MyAgreementsRoute
  '/my-cv': typeof MyCvRoute
  '/my-devices': typeof MyDevicesRoute
  '/my-diary': typeof MyDiaryRoute
  '/my-edu-interns': typeof MyEduInternsRoute
  '/my-org-interns': typeof MyOrgInternsRoute
  '/my-profile': typeof MyProfileRoute
  '/my-program': typeof MyProgramRoute
  '/my-workplace': typeof MyWorkplaceRoute
  '/org-agreements': typeof OrgAgreementsRoute
  '/org-interns': typeof OrgInternsRoute
  '/organization-profile': typeof OrganizationProfileRoute
  '/payment-return': typeof PaymentReturnRoute
  '/payments': typeof PaymentsRoute
  '/programs': typeof ProgramsRoute
  '/register-edu': typeof RegisterEduRoute
  '/register-org': typeof RegisterOrgRoute
  '/reset-password': typeof ResetPasswordRoute
  '/students': typeof StudentsRoute
  '/surveys': typeof SurveysRoute
  '/user-management': typeof UserManagementRoute
  '/users': typeof UsersRoute
  '/vacancies': typeof VacanciesRoute
  '/agreements_/sign': typeof AgreementsSignRoute
  '/edu-interns_/$internId': typeof EduInternsInternIdRoute
  '/eparaksts/$code': typeof EparakstsCodeRoute
  '/internships_/$internshipId': typeof InternshipsInternshipIdRoute
  '/my-edu-interns_/$internId': typeof MyEduInternsInternIdRoute
  '/my-org-interns_/$placementId': typeof MyOrgInternsPlacementIdRoute
  '/org-interns_/$placementId': typeof OrgInternsPlacementIdRoute
  '/organization-profile_/create': typeof OrganizationProfileCreateRoute
  '/surveys_/$surveyId': typeof SurveysSurveyIdRoute
  '/programs_/$programId/plan-points': typeof ProgramsProgramIdPlanPointsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/ProcessEparaksts'
    | '/absence'
    | '/accept-invite'
    | '/agreement-templates'
    | '/agreements'
    | '/applications'
    | '/complete-edu-registration'
    | '/edu-interns'
    | '/emails'
    | '/forgot-password'
    | '/future-internships'
    | '/grading'
    | '/institution-profile'
    | '/internship-hub'
    | '/internships'
    | '/login'
    | '/my-agreements'
    | '/my-cv'
    | '/my-devices'
    | '/my-diary'
    | '/my-edu-interns'
    | '/my-org-interns'
    | '/my-profile'
    | '/my-program'
    | '/my-workplace'
    | '/org-agreements'
    | '/org-interns'
    | '/organization-profile'
    | '/payment-return'
    | '/payments'
    | '/programs'
    | '/register-edu'
    | '/register-org'
    | '/reset-password'
    | '/students'
    | '/surveys'
    | '/user-management'
    | '/users'
    | '/vacancies'
    | '/agreements/sign'
    | '/edu-interns/$internId'
    | '/eparaksts/$code'
    | '/internships/$internshipId'
    | '/my-edu-interns/$internId'
    | '/my-org-interns/$placementId'
    | '/org-interns/$placementId'
    | '/organization-profile/create'
    | '/surveys/$surveyId'
    | '/programs/$programId/plan-points'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/ProcessEparaksts'
    | '/absence'
    | '/accept-invite'
    | '/agreement-templates'
    | '/agreements'
    | '/applications'
    | '/complete-edu-registration'
    | '/edu-interns'
    | '/emails'
    | '/forgot-password'
    | '/future-internships'
    | '/grading'
    | '/institution-profile'
    | '/internship-hub'
    | '/internships'
    | '/login'
    | '/my-agreements'
    | '/my-cv'
    | '/my-devices'
    | '/my-diary'
    | '/my-edu-interns'
    | '/my-org-interns'
    | '/my-profile'
    | '/my-program'
    | '/my-workplace'
    | '/org-agreements'
    | '/org-interns'
    | '/organization-profile'
    | '/payment-return'
    | '/payments'
    | '/programs'
    | '/register-edu'
    | '/register-org'
    | '/reset-password'
    | '/students'
    | '/surveys'
    | '/user-management'
    | '/users'
    | '/vacancies'
    | '/agreements/sign'
    | '/edu-interns/$internId'
    | '/eparaksts/$code'
    | '/internships/$internshipId'
    | '/my-edu-interns/$internId'
    | '/my-org-interns/$placementId'
    | '/org-interns/$placementId'
    | '/organization-profile/create'
    | '/surveys/$surveyId'
    | '/programs/$programId/plan-points'
  id:
    | '__root__'
    | '/'
    | '/ProcessEparaksts'
    | '/absence'
    | '/accept-invite'
    | '/agreement-templates'
    | '/agreements'
    | '/applications'
    | '/complete-edu-registration'
    | '/edu-interns'
    | '/emails'
    | '/forgot-password'
    | '/future-internships'
    | '/grading'
    | '/institution-profile'
    | '/internship-hub'
    | '/internships'
    | '/login'
    | '/my-agreements'
    | '/my-cv'
    | '/my-devices'
    | '/my-diary'
    | '/my-edu-interns'
    | '/my-org-interns'
    | '/my-profile'
    | '/my-program'
    | '/my-workplace'
    | '/org-agreements'
    | '/org-interns'
    | '/organization-profile'
    | '/payment-return'
    | '/payments'
    | '/programs'
    | '/register-edu'
    | '/register-org'
    | '/reset-password'
    | '/students'
    | '/surveys'
    | '/user-management'
    | '/users'
    | '/vacancies'
    | '/agreements_/sign'
    | '/edu-interns_/$internId'
    | '/eparaksts/$code'
    | '/internships_/$internshipId'
    | '/my-edu-interns_/$internId'
    | '/my-org-interns_/$placementId'
    | '/org-interns_/$placementId'
    | '/organization-profile_/create'
    | '/surveys_/$surveyId'
    | '/programs_/$programId/plan-points'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ProcessEparakstsRoute: typeof ProcessEparakstsRoute
  AbsenceRoute: typeof AbsenceRoute
  AcceptInviteRoute: typeof AcceptInviteRoute
  AgreementTemplatesRoute: typeof AgreementTemplatesRoute
  AgreementsRoute: typeof AgreementsRoute
  ApplicationsRoute: typeof ApplicationsRoute
  CompleteEduRegistrationRoute: typeof CompleteEduRegistrationRoute
  EduInternsRoute: typeof EduInternsRoute
  EmailsRoute: typeof EmailsRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  FutureInternshipsRoute: typeof FutureInternshipsRoute
  GradingRoute: typeof GradingRoute
  InstitutionProfileRoute: typeof InstitutionProfileRoute
  InternshipHubRoute: typeof InternshipHubRoute
  InternshipsRoute: typeof InternshipsRoute
  LoginRoute: typeof LoginRoute
  MyAgreementsRoute: typeof MyAgreementsRoute
  MyCvRoute: typeof MyCvRoute
  MyDevicesRoute: typeof MyDevicesRoute
  MyDiaryRoute: typeof MyDiaryRoute
  MyEduInternsRoute: typeof MyEduInternsRoute
  MyOrgInternsRoute: typeof MyOrgInternsRoute
  MyProfileRoute: typeof MyProfileRoute
  MyProgramRoute: typeof MyProgramRoute
  MyWorkplaceRoute: typeof MyWorkplaceRoute
  OrgAgreementsRoute: typeof OrgAgreementsRoute
  OrgInternsRoute: typeof OrgInternsRoute
  OrganizationProfileRoute: typeof OrganizationProfileRoute
  PaymentReturnRoute: typeof PaymentReturnRoute
  PaymentsRoute: typeof PaymentsRoute
  ProgramsRoute: typeof ProgramsRoute
  RegisterEduRoute: typeof RegisterEduRoute
  RegisterOrgRoute: typeof RegisterOrgRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  StudentsRoute: typeof StudentsRoute
  SurveysRoute: typeof SurveysRoute
  UserManagementRoute: typeof UserManagementRoute
  UsersRoute: typeof UsersRoute
  VacanciesRoute: typeof VacanciesRoute
  AgreementsSignRoute: typeof AgreementsSignRoute
  EduInternsInternIdRoute: typeof EduInternsInternIdRoute
  EparakstsCodeRoute: typeof EparakstsCodeRoute
  InternshipsInternshipIdRoute: typeof InternshipsInternshipIdRoute
  MyEduInternsInternIdRoute: typeof MyEduInternsInternIdRoute
  MyOrgInternsPlacementIdRoute: typeof MyOrgInternsPlacementIdRoute
  OrgInternsPlacementIdRoute: typeof OrgInternsPlacementIdRoute
  OrganizationProfileCreateRoute: typeof OrganizationProfileCreateRoute
  SurveysSurveyIdRoute: typeof SurveysSurveyIdRoute
  ProgramsProgramIdPlanPointsRoute: typeof ProgramsProgramIdPlanPointsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ProcessEparaksts': {
      id: '/ProcessEparaksts'
      path: '/ProcessEparaksts'
      fullPath: '/ProcessEparaksts'
      preLoaderRoute: typeof ProcessEparakstsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/absence': {
      id: '/absence'
      path: '/absence'
      fullPath: '/absence'
      preLoaderRoute: typeof AbsenceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invite': {
      id: '/accept-invite'
      path: '/accept-invite'
      fullPath: '/accept-invite'
      preLoaderRoute: typeof AcceptInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agreement-templates': {
      id: '/agreement-templates'
      path: '/agreement-templates'
      fullPath: '/agreement-templates'
      preLoaderRoute: typeof AgreementTemplatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agreements': {
      id: '/agreements'
      path: '/agreements'
      fullPath: '/agreements'
      preLoaderRoute: typeof AgreementsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/applications': {
      id: '/applications'
      path: '/applications'
      fullPath: '/applications'
      preLoaderRoute: typeof ApplicationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/complete-edu-registration': {
      id: '/complete-edu-registration'
      path: '/complete-edu-registration'
      fullPath: '/complete-edu-registration'
      preLoaderRoute: typeof CompleteEduRegistrationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/edu-interns': {
      id: '/edu-interns'
      path: '/edu-interns'
      fullPath: '/edu-interns'
      preLoaderRoute: typeof EduInternsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/emails': {
      id: '/emails'
      path: '/emails'
      fullPath: '/emails'
      preLoaderRoute: typeof EmailsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/future-internships': {
      id: '/future-internships'
      path: '/future-internships'
      fullPath: '/future-internships'
      preLoaderRoute: typeof FutureInternshipsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/grading': {
      id: '/grading'
      path: '/grading'
      fullPath: '/grading'
      preLoaderRoute: typeof GradingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/institution-profile': {
      id: '/institution-profile'
      path: '/institution-profile'
      fullPath: '/institution-profile'
      preLoaderRoute: typeof InstitutionProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/internship-hub': {
      id: '/internship-hub'
      path: '/internship-hub'
      fullPath: '/internship-hub'
      preLoaderRoute: typeof InternshipHubRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/internships': {
      id: '/internships'
      path: '/internships'
      fullPath: '/internships'
      preLoaderRoute: typeof InternshipsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-agreements': {
      id: '/my-agreements'
      path: '/my-agreements'
      fullPath: '/my-agreements'
      preLoaderRoute: typeof MyAgreementsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-cv': {
      id: '/my-cv'
      path: '/my-cv'
      fullPath: '/my-cv'
      preLoaderRoute: typeof MyCvRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-devices': {
      id: '/my-devices'
      path: '/my-devices'
      fullPath: '/my-devices'
      preLoaderRoute: typeof MyDevicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-diary': {
      id: '/my-diary'
      path: '/my-diary'
      fullPath: '/my-diary'
      preLoaderRoute: typeof MyDiaryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-edu-interns': {
      id: '/my-edu-interns'
      path: '/my-edu-interns'
      fullPath: '/my-edu-interns'
      preLoaderRoute: typeof MyEduInternsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-org-interns': {
      id: '/my-org-interns'
      path: '/my-org-interns'
      fullPath: '/my-org-interns'
      preLoaderRoute: typeof MyOrgInternsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-profile': {
      id: '/my-profile'
      path: '/my-profile'
      fullPath: '/my-profile'
      preLoaderRoute: typeof MyProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-program': {
      id: '/my-program'
      path: '/my-program'
      fullPath: '/my-program'
      preLoaderRoute: typeof MyProgramRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-workplace': {
      id: '/my-workplace'
      path: '/my-workplace'
      fullPath: '/my-workplace'
      preLoaderRoute: typeof MyWorkplaceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/org-agreements': {
      id: '/org-agreements'
      path: '/org-agreements'
      fullPath: '/org-agreements'
      preLoaderRoute: typeof OrgAgreementsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/org-interns': {
      id: '/org-interns'
      path: '/org-interns'
      fullPath: '/org-interns'
      preLoaderRoute: typeof OrgInternsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organization-profile': {
      id: '/organization-profile'
      path: '/organization-profile'
      fullPath: '/organization-profile'
      preLoaderRoute: typeof OrganizationProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payment-return': {
      id: '/payment-return'
      path: '/payment-return'
      fullPath: '/payment-return'
      preLoaderRoute: typeof PaymentReturnRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments': {
      id: '/payments'
      path: '/payments'
      fullPath: '/payments'
      preLoaderRoute: typeof PaymentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/programs': {
      id: '/programs'
      path: '/programs'
      fullPath: '/programs'
      preLoaderRoute: typeof ProgramsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register-edu': {
      id: '/register-edu'
      path: '/register-edu'
      fullPath: '/register-edu'
      preLoaderRoute: typeof RegisterEduRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register-org': {
      id: '/register-org'
      path: '/register-org'
      fullPath: '/register-org'
      preLoaderRoute: typeof RegisterOrgRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/students': {
      id: '/students'
      path: '/students'
      fullPath: '/students'
      preLoaderRoute: typeof StudentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/surveys': {
      id: '/surveys'
      path: '/surveys'
      fullPath: '/surveys'
      preLoaderRoute: typeof SurveysRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user-management': {
      id: '/user-management'
      path: '/user-management'
      fullPath: '/user-management'
      preLoaderRoute: typeof UserManagementRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vacancies': {
      id: '/vacancies'
      path: '/vacancies'
      fullPath: '/vacancies'
      preLoaderRoute: typeof VacanciesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agreements_/sign': {
      id: '/agreements_/sign'
      path: '/agreements/sign'
      fullPath: '/agreements/sign'
      preLoaderRoute: typeof AgreementsSignRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/edu-interns_/$internId': {
      id: '/edu-interns_/$internId'
      path: '/edu-interns/$internId'
      fullPath: '/edu-interns/$internId'
      preLoaderRoute: typeof EduInternsInternIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eparaksts/$code': {
      id: '/eparaksts/$code'
      path: '/eparaksts/$code'
      fullPath: '/eparaksts/$code'
      preLoaderRoute: typeof EparakstsCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/internships_/$internshipId': {
      id: '/internships_/$internshipId'
      path: '/internships/$internshipId'
      fullPath: '/internships/$internshipId'
      preLoaderRoute: typeof InternshipsInternshipIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-edu-interns_/$internId': {
      id: '/my-edu-interns_/$internId'
      path: '/my-edu-interns/$internId'
      fullPath: '/my-edu-interns/$internId'
      preLoaderRoute: typeof MyEduInternsInternIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-org-interns_/$placementId': {
      id: '/my-org-interns_/$placementId'
      path: '/my-org-interns/$placementId'
      fullPath: '/my-org-interns/$placementId'
      preLoaderRoute: typeof MyOrgInternsPlacementIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/org-interns_/$placementId': {
      id: '/org-interns_/$placementId'
      path: '/org-interns/$placementId'
      fullPath: '/org-interns/$placementId'
      preLoaderRoute: typeof OrgInternsPlacementIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organization-profile_/create': {
      id: '/organization-profile_/create'
      path: '/organization-profile/create'
      fullPath: '/organization-profile/create'
      preLoaderRoute: typeof OrganizationProfileCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/surveys_/$surveyId': {
      id: '/surveys_/$surveyId'
      path: '/surveys/$surveyId'
      fullPath: '/surveys/$surveyId'
      preLoaderRoute: typeof SurveysSurveyIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/programs_/$programId/plan-points': {
      id: '/programs_/$programId/plan-points'
      path: '/programs/$programId/plan-points'
      fullPath: '/programs/$programId/plan-points'
      preLoaderRoute: typeof ProgramsProgramIdPlanPointsRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ProcessEparakstsRoute: ProcessEparakstsRoute,
  AbsenceRoute: AbsenceRoute,
  AcceptInviteRoute: AcceptInviteRoute,
  AgreementTemplatesRoute: AgreementTemplatesRoute,
  AgreementsRoute: AgreementsRoute,
  ApplicationsRoute: ApplicationsRoute,
  CompleteEduRegistrationRoute: CompleteEduRegistrationRoute,
  EduInternsRoute: EduInternsRoute,
  EmailsRoute: EmailsRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  FutureInternshipsRoute: FutureInternshipsRoute,
  GradingRoute: GradingRoute,
  InstitutionProfileRoute: InstitutionProfileRoute,
  InternshipHubRoute: InternshipHubRoute,
  InternshipsRoute: InternshipsRoute,
  LoginRoute: LoginRoute,
  MyAgreementsRoute: MyAgreementsRoute,
  MyCvRoute: MyCvRoute,
  MyDevicesRoute: MyDevicesRoute,
  MyDiaryRoute: MyDiaryRoute,
  MyEduInternsRoute: MyEduInternsRoute,
  MyOrgInternsRoute: MyOrgInternsRoute,
  MyProfileRoute: MyProfileRoute,
  MyProgramRoute: MyProgramRoute,
  MyWorkplaceRoute: MyWorkplaceRoute,
  OrgAgreementsRoute: OrgAgreementsRoute,
  OrgInternsRoute: OrgInternsRoute,
  OrganizationProfileRoute: OrganizationProfileRoute,
  PaymentReturnRoute: PaymentReturnRoute,
  PaymentsRoute: PaymentsRoute,
  ProgramsRoute: ProgramsRoute,
  RegisterEduRoute: RegisterEduRoute,
  RegisterOrgRoute: RegisterOrgRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  StudentsRoute: StudentsRoute,
  SurveysRoute: SurveysRoute,
  UserManagementRoute: UserManagementRoute,
  UsersRoute: UsersRoute,
  VacanciesRoute: VacanciesRoute,
  AgreementsSignRoute: AgreementsSignRoute,
  EduInternsInternIdRoute: EduInternsInternIdRoute,
  EparakstsCodeRoute: EparakstsCodeRoute,
  InternshipsInternshipIdRoute: InternshipsInternshipIdRoute,
  MyEduInternsInternIdRoute: MyEduInternsInternIdRoute,
  MyOrgInternsPlacementIdRoute: MyOrgInternsPlacementIdRoute,
  OrgInternsPlacementIdRoute: OrgInternsPlacementIdRoute,
  OrganizationProfileCreateRoute: OrganizationProfileCreateRoute,
  SurveysSurveyIdRoute: SurveysSurveyIdRoute,
  ProgramsProgramIdPlanPointsRoute: ProgramsProgramIdPlanPointsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
